import { Component, OnInit } from '@angular/core';
import {
  FilterModel,
  TableData,
  TablesComponent,
} from '../../components/tables/tables.component';
import { CommonModule, DatePipe } from '@angular/common';
import {
  AdminReportFilterModel,
  ReportService,
} from '../../../core/services/report/report.service';

@Component({
  selector: 'app-analysis-report-list',
  standalone: true,
  imports: [TablesComponent, CommonModule, DatePipe],
  templateUrl: './analysis-report-list.component.html',
  styleUrl: './analysis-report-list.component.scss',
  providers: [DatePipe],
})
export class AnalysisReportListComponent implements OnInit {
  maxDate: string;
  columns: string[] = [];
  filters: string[] = [];
  data: TableData[] = [];

  totalCount: number = 0;
  totalPage: number = 0;
  pageSize: number = 10;
  pageSizes = [10, 25, 50, 100];
  currentPage: number = 1;

  filterModel: AdminReportFilterModel = {
    customerCode: '',
    year: null,
    month: null,
  };

  constructor(private reportService: ReportService) {
    const today = new Date();
    this.maxDate = today.toISOString().split('T')[0];

    this.columns = ['customerCode', 'year', 'month', 'imageCount', 'analysisCount'];
    this.filters = ['customerCode', 'year', 'month'];
  }
  ngOnInit(): void {
    this.getAnalysisReportList(this.currentPage, this.pageSize);
  }

  getAnalysisReportList(
    page: number,
    size: number,
    filters?: AdminReportFilterModel
  ): void {
    this.reportService.analysisReportList(page, size, filters).subscribe({
      next: (res) => {
        this.data = res.items;
        this.totalCount = res.count;
        this.totalPage = res.pages;
        this.pageSize = res.size;
        this.currentPage = page;
      },
      error: () => {
        // this.toastMessage = 'Error occured while getting the user list.';
        // this.toastType = 'error';
      },
    });
  }

  onChangeFilterValues(e: FilterModel) {
    this.filterModel = {
      customerCode: e.customerCode,
      year: e.year,
      month: e.month,
    };
    this.getAnalysisReportList(1, this.pageSize, this.filterModel);
  }

  changePage(e: any): void {
    if (e.page > 0 && e.page <= this.totalPage) {
      this.getAnalysisReportList(e.page, e.pageSize, this.filterModel);
    }
  }
}
